import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';
import LegacyDropDown from '../legacy-dropdown';

const LegacyNavBar = function LegacyNavBar({ legacyurl, email }) {
    const { host, protocol } = new URL(window.location.href);

    const accountSettingUrl = `${protocol}//${host}/Portal/Client/Settings/Legacy`;
    const logoffUrl = `${legacyurl}/Account/Logoff`;

    const logoUrl = `${legacyurl}/Account/Dashboard`;
    const logoSrc = `${legacyurl}/img/logos/giveeasy_reversed_logo.png`;

    return (
        <nav className={`${styles['legacy-navbar']} ${styles['no-border']}`} role="navigation">
            <div className={styles.container}>
                <a href={logoUrl}>
                    <img className={styles.logo} src={logoSrc} alt="GiveEasy Logo" />
                </a>
                <div className={styles['legacy-navbar-menu']}>
                    <LegacyDropDown
                        trigger={(
                            <>
                                <i className="fa fa-user fa-fw" />
                                <span className={styles.email}>{email}</span>
                                <i className="fa fa-caret-down" />
                            </>
                        )}
                        options={[
                            {
                                href: accountSettingUrl,
                                value: (
                                    <>
                                        <i className="fa fa-gear fa-fw" />
                                        Account Settings
                                    </>
                                ),
                            },
                            {
                                href: logoffUrl,
                                value: (
                                    <>
                                        <i className="fa fa-sign-out fa-fw" />
                                        Logout
                                    </>
                                ),
                            },
                        ]}
                    />
                </div>
            </div>
        </nav>
    );
};

LegacyNavBar.propTypes = {
    legacyurl: PropTypes.string.isRequired,
    email: PropTypes.string,
};

LegacyNavBar.defaultProps = {
    email: '',
};

export default LegacyNavBar;
